import { Type, User } from '../network/types';
import { getRetailUnitAndLanguage } from '../network/utils/getRetailUnitAndLanguage';
import { getEnv } from './env';

const SUPPORTED_RETAIL_UNITS = ['my'];

export function setInsiderObject(user: User) {
  const { retailUnit } = getRetailUnitAndLanguage();
  const env = getEnv();

  if (user.type === Type.GUEST || !SUPPORTED_RETAIL_UNITS.includes(retailUnit) || env === 'production') return;

  if (!user.custom.emailAddress || !user.custom.userId) throw new Error('Email or userId not found');

  window.insider_object = window.insider_object ?? {};

  window.insider_object.user = {
    email: user.custom.emailAddress,
    custom_identifiers: {
      userid: user.custom.userId,
    },
  };
}
